
if (!customElements.get('sub-collection')) {
    customElements.define(
        'sub-collection',
        class SubCollection extends HTMLElement {
            constructor() {
                super();
            }
            connectedCallback() {
                this.selectors = {
                    sliderWrapper: '.custom-content__items',
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                };
                this.classes = {
                    grid: 'f-grid',
                    swiper: 'swiper',
                    swiperWrapper: 'swiper-wrapper',
                };
                this.sectionId = this.dataset.sectionId;
                this.section = this.closest(`.section-${this.sectionId}`);
                this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

                this.enableSlider = this.dataset.enableSlider === 'true';
                this.items = parseInt(this.dataset.items);
                this.tabletItems = parseInt(this.dataset.tabletItems);
                this.gap_slider = parseInt(this.dataset.gapSlider) || 0;
                this.sliderInstance = false;
                if (!this.enableSlider) {
                    return;
                }
                const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
                mql.onchange = this.init.bind(this);
                this.init();
            }

            init() {
                if (FoxTheme.config.mqlMobile) {
                    this.destroySlider();
                } else {
                    this.initSlider();
                }
            }

            initSlider() {
                // if (typeof this.sliderInstance === 'object') return;
                // const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--column-gap');
                this.sliderOptions = {
                    slidesPerView: 6,
                    spaceBetween: this.gap_slider,
                    navigation: {
                        nextEl: this.section.querySelector(this.selectors.nextEl),
                        prevEl: this.section.querySelector(this.selectors.prevEl),
                    },
                    pagination: false,
                    breakpoints: {
                    768: {
                        slidesPerView: 4,
                    },
                    1024: {
                        slidesPerView: 6,
                    },
                    },
                    loop: false,
                    threshold: 2,
                };

                this.classList.add(this.classes.swiper);
                this.sliderWrapper.classList.remove(this.classes.grid);
                this.sliderWrapper.classList.add(this.classes.swiperWrapper);

                this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions);
                this.sliderInstance.init();
            }

            destroySlider() {
                this.classList.remove(this.classes.swiper);
                this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
                this.sliderWrapper.classList.add(this.classes.grid);
                if (typeof this.sliderInstance !== 'object') return;
                this.sliderInstance.slider.destroy();
                this.sliderInstance = false;
            }
        }
    );
}
